import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MainModule } from '../app/views/main/main.module';
import { LoginModule } from '../app/views/login/login.module';
import { ModalService } from './shared/services/modal.service';
import { ToastrModule } from 'ngx-toastr';
import { HomeModule } from './views/home/home.module';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { WINDOW, WINDOW_PROVIDERS } from '../app/window_provider';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    ToastrModule.forRoot({
      preventDuplicates: true
    }),
    MainModule,
    LoginModule,
    HomeModule,
    TabsModule.forRoot(),
  ],
  providers: [
    ModalService,
    Title,
    WINDOW_PROVIDERS
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
